import { EventEmitter, Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { breakpointBelow, ResponsiveService, SharedDirectiveModule } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NzCardModule } from 'ng-zorro-antd/card';
import { CommonModule } from '@angular/common';
import { FundTypeIcon, BondsTypeIcon, EtfsTypeIcon, DpmsTypeIcon, InsuranceTypeIcon, StocksTypeIcon, CashTypeIcon, AboutTypeIcon, ChartCentreSmallIcon, FundSelectorSmallIcon, NewFundsSmallIcon, PortfolioSimulatorSmallIcon, RecommendedFundsSmallIcon, TransferInConsolidatedStatementIcon, TransferInEasyMonitoringIcon, TransferInFreeTransferInIcon, PaymentMethodsIcon, FeesIcon, OngoingMonitoringIcon, HolisticPortfoliosIcon, AutoPortfolioRebalancingIcon, DpmsHompagePortfolioArticleIcon, AccountOpeningCorporateIcon, AccountOpeningPersonalIcon, BenifitsRebalancingIcon, StockScreenerSmallIcon, BondYieldCurveSmallIcon, LiveTradingSmallIcon, CompanyAnnouncementIcon, BondCalculatorIcon, NewBondsIcon, DmpsHompageFindMyPortfolioIcon, RecommendedFundsMethodologyIcon, RiskRatingOverviewIcon, InsureOnlineIcon, CompareInsIcon, GetQuoteIcon, StocksEtfsTypeIcon, EtfChartCenterIcon, EtfFocusListSmallIcon, EtfSelectorIcon, RewardsTypeIcon, ResearchTypeIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-type.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CProductTypeModule } from 'b2c-ui/product-type';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'b2c-ui-icon';
import * as ɵngcc4 from 'ng-zorro-antd/card';

function B2CProductTypeComponent_ng_container_0_a_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProductTypeComponent_ng_container_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵtemplate(1, B2CProductTypeComponent_ng_container_0_a_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("link", ctx_r10.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function B2CProductTypeComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CProductTypeComponent_ng_container_0_a_1_Template, 2, 2, "a", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.shape === "default")("ngIfElse", _r6);
} }
function B2CProductTypeComponent_ng_template_1_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.title);
} }
function B2CProductTypeComponent_ng_template_1_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15.description);
} }
function B2CProductTypeComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵlistener("click", function B2CProductTypeComponent_ng_template_1_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.emitProductClick(); });
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelement(4, "b2c-ui-icon", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CProductTypeComponent_ng_template_1_div_0_span_5_Template, 2, 1, "span", 15);
    ɵngcc0.ɵɵtemplate(6, B2CProductTypeComponent_ng_template_1_div_0_span_6_Template, 2, 1, "span", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r12.showBg ? "showBg" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", ctx_r12.iconName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.description);
} }
function B2CProductTypeComponent_ng_template_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProductTypeComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, B2CProductTypeComponent_ng_template_1_div_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function B2CProductTypeComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CProductTypeComponent_ng_template_1_div_0_Template, 7, 4, "div", 9);
    ɵngcc0.ɵɵtemplate(1, B2CProductTypeComponent_ng_template_1_div_1_Template, 2, 1, "div", 2);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isMobile);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isMobile && ctx_r2.link);
} }
function B2CProductTypeComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProductTypeComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, B2CProductTypeComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function B2CProductTypeComponent_ng_template_4_ng_container_0_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r21.title);
} }
function B2CProductTypeComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelement(4, "b2c-ui-icon", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CProductTypeComponent_ng_template_4_ng_container_0_span_5_Template, 2, 1, "span", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("name", ctx_r20.iconName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r20.title);
} }
function B2CProductTypeComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CProductTypeComponent_ng_template_4_ng_container_0_Template, 6, 2, "ng-container", 0);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r8 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.mobileShape === "default")("ngIfElse", _r8);
} }
function B2CProductTypeComponent_ng_template_6_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r22.title);
} }
function B2CProductTypeComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵelementStart(2, "div", 22);
    ɵngcc0.ɵɵelement(3, "b2c-ui-icon", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, B2CProductTypeComponent_ng_template_6_p_4_Template, 2, 1, "p", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("name", ctx_r7.iconName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.title);
} }
function B2CProductTypeComponent_ng_template_8_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r23.title);
} }
function B2CProductTypeComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nz-card", 26);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelement(4, "b2c-ui-icon", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CProductTypeComponent_ng_template_8_span_5_Template, 2, 1, "span", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.showBg ? "showBg" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", ctx_r9.iconName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.title);
} }
class B2CProductTypeComponent {
    /**
     * @ignore
     * @param {?} elementRef
     * @param {?} cdRef
     * @param {?} responsiveService
     */
    constructor(elementRef, cdRef, responsiveService) {
        this.elementRef = elementRef;
        this.cdRef = cdRef;
        this.responsiveService = responsiveService;
        /**
         * Set Shape
         */
        this.shape = 'default';
        this.showBg = false;
        /**
         * Set Mobile Shape
         */
        this.mobileShape = 'default';
        /**
         * Set Link Redirection
         */
        this.redirection = true;
        /**
         * Click Product Event
         */
        this.productClick = new EventEmitter();
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set Mobile View
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * @return {?}
     */
    emitProductClick() {
        this.productClick.emit();
    }
}
B2CProductTypeComponent.ɵfac = function B2CProductTypeComponent_Factory(t) { return new (t || B2CProductTypeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
B2CProductTypeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProductTypeComponent, selectors: [["b2c-product-type"]], inputs: { shape: "shape", showBg: "showBg", mobileShape: "mobileShape", redirection: "redirection", isMobile: "isMobile", link: "link", description: "description", iconName: "iconName", title: "title" }, outputs: { productClick: "productClick" }, decls: 10, vars: 3, consts: [[4, "ngIf", "ngIfElse"], ["productContent", ""], ["class", "b2c-product-type-mobile", 4, "ngIf"], ["mobileProductType", ""], ["circleProductType", ""], ["squareShape", ""], ["external", "", 3, "link", 4, "ngIf", "ngIfElse"], ["external", "", 3, "link"], [4, "ngTemplateOutlet"], ["class", "h-100 w-100 bg-white p-3 rounded b2c-product-type-web", "role", "button", 3, "click", 4, "ngIf"], ["role", "button", 1, "h-100", "w-100", "bg-white", "p-3", "rounded", "b2c-product-type-web", 3, "click"], [1, "b2c-product-type-card", "d-flex", "flex-column", "h-100", "text-center"], [1, "b2c-ui-icon-container", "mx-auto", "rounded-circle", "position-relative", 3, "ngClass"], [1, "w-100", "h-100", "rounded-circle", "d-flex"], [1, "icon", "m-auto", 3, "name"], ["class", "b2c-product-type-title", 4, "ngIf"], ["class", "b2c-product-type-description mx-auto w-85 text-center ", 4, "ngIf"], [1, "b2c-product-type-title"], [1, "b2c-product-type-description", "mx-auto", "w-85", "text-center"], [1, "b2c-product-type-mobile"], [1, "b2c-ui-icon-container", "mx-auto", "rounded-circle", "position-relative"], [1, "b2c-product-type-circle", "text-center"], [1, "w-100", "h-100", "d-flex"], [1, "icon-fund", "m-auto", 3, "name"], ["class", "b2c-product-type-title m-0", 4, "ngIf"], [1, "b2c-product-type-title", "m-0"], [1, "h-100", "b2c-product-type-mobile-square"], [1, "b2c-ui-icon-container", "w-100", "mx-auto", "rounded-circle", "position-relative", 3, "ngClass"]], template: function B2CProductTypeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, B2CProductTypeComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, B2CProductTypeComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, B2CProductTypeComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, B2CProductTypeComponent_ng_template_4_Template, 1, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, B2CProductTypeComponent_ng_template_6_Template, 5, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, B2CProductTypeComponent_ng_template_8_Template, 6, 3, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.redirection)("ngIfElse", _r1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile && !ctx.link);
    } }, directives: [ɵngcc2.NgIf, ɵngcc1.ExternalLinkDirective, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgClass, ɵngcc3.B2CUiIconComponent, ɵngcc4.NzCardComponent], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CProductTypeComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: ResponsiveService }
];
B2CProductTypeComponent.propDecorators = {
    isMobile: [{ type: Input }],
    link: [{ type: Input }],
    description: [{ type: Input }],
    iconName: [{ type: Input }],
    title: [{ type: Input }],
    shape: [{ type: Input }],
    showBg: [{ type: Input }],
    mobileShape: [{ type: Input }],
    redirection: [{ type: Input }],
    productClick: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductTypeComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-product-type',
                template: "<ng-container *ngIf=\"redirection; else productContent\">\r\n  <a external [link]=\"link\" *ngIf=\"shape === 'default'; else circleProductType\">\r\n    <ng-container *ngTemplateOutlet=\"productContent\"></ng-container>\r\n  </a>\r\n</ng-container>\r\n\r\n<ng-template #productContent>\r\n  <div class=\"h-100 w-100 bg-white p-3 rounded b2c-product-type-web\" *ngIf=\"!isMobile\" (click)=\"emitProductClick()\" role=\"button\">\r\n    <div class=\"b2c-product-type-card d-flex flex-column h-100 text-center\">\r\n      <div class=\"b2c-ui-icon-container mx-auto rounded-circle position-relative\" [ngClass]=\"showBg? 'showBg':''\" >\r\n        <div class=\"w-100 h-100 rounded-circle d-flex\">\r\n          <b2c-ui-icon  class=\"icon m-auto\" [name]=\"iconName\"></b2c-ui-icon>\r\n        </div>\r\n      </div>\r\n      <span *ngIf=\"title\" class=\"b2c-product-type-title\">{{title}}</span>\r\n      <span *ngIf=\"description\" class=\"b2c-product-type-description mx-auto w-85 text-center \">{{description}}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"b2c-product-type-mobile\" *ngIf=\"isMobile && link\">\r\n    <ng-container *ngTemplateOutlet=\"mobileProductType\"></ng-container>\r\n  </div>\r\n</ng-template>\r\n\r\n<div class=\"b2c-product-type-mobile\" *ngIf=\"isMobile && !link\">\r\n  <ng-container *ngTemplateOutlet=\"mobileProductType\"></ng-container>\r\n</div>\r\n\r\n<ng-template #mobileProductType>\r\n  <ng-container *ngIf=\"mobileShape === 'default'; else squareShape\">\r\n    <div class=\"b2c-product-type-card d-flex flex-column h-100 text-center\">\r\n      <div class=\"b2c-ui-icon-container mx-auto rounded-circle position-relative\"  >\r\n        <div class=\"w-100 h-100 rounded-circle d-flex\">\r\n            <b2c-ui-icon class=\"icon m-auto\" [name]=\"iconName\"></b2c-ui-icon>\r\n        </div>\r\n      </div>\r\n      <span *ngIf=\"title\" class=\"b2c-product-type-title\">{{title}}</span>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #circleProductType>\r\n  <div class=\"b2c-product-type-circle text-center\">\r\n    <div class=\"b2c-ui-icon-container mx-auto rounded-circle position-relative\"  >\r\n\r\n      <div class=\"w-100 h-100 d-flex\">\r\n        <b2c-ui-icon  class=\"icon-fund m-auto\" [name]=\"iconName\"></b2c-ui-icon>\r\n      </div>\r\n  </div>\r\n  <p *ngIf=\"title\" class=\"b2c-product-type-title m-0\">{{title}}</p>\r\n\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #squareShape>\r\n  <nz-card class=\"h-100 b2c-product-type-mobile-square\">\r\n    <div class=\"b2c-product-type-card d-flex flex-column h-100 text-center\">\r\n      <div class=\"b2c-ui-icon-container w-100 mx-auto rounded-circle position-relative\" [ngClass]=\"showBg? 'showBg':''\" >\r\n        <div class=\"w-100 h-100 rounded-circle d-flex\">\r\n          <b2c-ui-icon  class=\"icon m-auto\" [name]=\"iconName\"></b2c-ui-icon>\r\n        </div>\r\n      </div>\r\n      <span *ngIf=\"title\" class=\"b2c-product-type-title\">{{title}}</span>\r\n    </div>\r\n  </nz-card>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.ResponsiveService }]; }, { shape: [{
            type: Input
        }], showBg: [{
            type: Input
        }], mobileShape: [{
            type: Input
        }], redirection: [{
            type: Input
        }], productClick: [{
            type: Output
        }], isMobile: [{
            type: Input
        }], link: [{
            type: Input
        }], description: [{
            type: Input
        }], iconName: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CProductTypeComponent.prototype._isMobile;
    /**
     * Set Link
     * @type {?}
     */
    B2CProductTypeComponent.prototype.link;
    /**
     * Set Description
     * @type {?}
     */
    B2CProductTypeComponent.prototype.description;
    /**
     * Set Product Icon
     * @type {?}
     */
    B2CProductTypeComponent.prototype.iconName;
    /**
     * Set Title
     * @type {?}
     */
    B2CProductTypeComponent.prototype.title;
    /**
     * Set Shape
     * @type {?}
     */
    B2CProductTypeComponent.prototype.shape;
    /** @type {?} */
    B2CProductTypeComponent.prototype.showBg;
    /**
     * Set Mobile Shape
     * @type {?}
     */
    B2CProductTypeComponent.prototype.mobileShape;
    /**
     * Set Link Redirection
     * @type {?}
     */
    B2CProductTypeComponent.prototype.redirection;
    /**
     * Click Product Event
     * @type {?}
     */
    B2CProductTypeComponent.prototype.productClick;
    /** @type {?} */
    B2CProductTypeComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    B2CProductTypeComponent.prototype.cdRef;
    /**
     * @type {?}
     * @private
     */
    B2CProductTypeComponent.prototype.responsiveService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-type.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [
    FundTypeIcon,
    BondsTypeIcon,
    EtfsTypeIcon,
    DpmsTypeIcon,
    InsuranceTypeIcon,
    StocksTypeIcon,
    CashTypeIcon,
    AboutTypeIcon,
    ChartCentreSmallIcon,
    FundSelectorSmallIcon,
    NewFundsSmallIcon,
    PortfolioSimulatorSmallIcon,
    RecommendedFundsSmallIcon,
    TransferInConsolidatedStatementIcon,
    TransferInEasyMonitoringIcon,
    TransferInFreeTransferInIcon,
    PaymentMethodsIcon,
    FeesIcon,
    OngoingMonitoringIcon,
    HolisticPortfoliosIcon,
    AutoPortfolioRebalancingIcon,
    DpmsHompagePortfolioArticleIcon,
    AccountOpeningCorporateIcon,
    AccountOpeningPersonalIcon,
    BenifitsRebalancingIcon,
    StockScreenerSmallIcon,
    BondYieldCurveSmallIcon,
    LiveTradingSmallIcon,
    CompanyAnnouncementIcon,
    BondCalculatorIcon,
    NewBondsIcon,
    DmpsHompageFindMyPortfolioIcon,
    RecommendedFundsMethodologyIcon,
    RiskRatingOverviewIcon,
    InsureOnlineIcon,
    CompareInsIcon,
    GetQuoteIcon,
    StocksEtfsTypeIcon,
    EtfChartCenterIcon,
    EtfFocusListSmallIcon,
    EtfSelectorIcon,
    RewardsTypeIcon,
    ResearchTypeIcon
];
class B2CProductTypeModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CProductTypeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CProductTypeModule });
B2CProductTypeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CProductTypeModule_Factory(t) { return new (t || B2CProductTypeModule)(ɵngcc0.ɵɵinject(ɵngcc3.B2CUiIconService)); }, imports: [[CommonModule, NzCardModule, B2cUiIconModule, SharedDirectiveModule]] });
/** @nocollapse */
B2CProductTypeModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CProductTypeModule, { declarations: function () { return [B2CProductTypeComponent]; }, imports: function () { return [CommonModule, NzCardModule, B2cUiIconModule, SharedDirectiveModule]; }, exports: function () { return [B2CProductTypeComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductTypeModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CProductTypeComponent],
                exports: [B2CProductTypeComponent],
                imports: [CommonModule, NzCardModule, B2cUiIconModule, SharedDirectiveModule]
            }]
    }], function () { return [{ type: ɵngcc3.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CProductTypeModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-product-type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CProductTypeComponent, B2CProductTypeModule };


//# sourceMappingURL=b2c-ui-product-type.js.map